export default {
  t: {
    select: {
      placeholder: '请选择',
      noMatch: '无匹配数据',
      loadMore: '加载更多',
      loading: '加载中'
    },
    table: {
      noDataText: '暂无数据',
      noFilteredDataText: '暂无筛选结果',
      confirmFilter: '筛选',
      resetFilter: '重置',
      clearFilter: '全部',
      loading: '<h2 class="text-primary "><i class="aid-ani-loop aid aid-loading icon-gradient-primary"></i></h2> 正在加载数据...'
    },
    datepicker: {
      selectDate: '选择日期',
      selectTime: '选择时间',
      startTime: '开始时间',
      endTime: '结束时间',
      clear: '清空',
      ok: '确定',
      dataError: '数据错误',
      placeholder: '请选择',
      prevMonthBtn: '显示上个月',
      nextMonthBtn: '显示下个月',
      prevDecade: '显示上十年',
      nextDecade: '显示下十年',
      today: '今天',
      inLastWeek: '最近一周',
      inLastMonth: '最近一个月',
      lastWeek: '上一周',
      lastMonth: '上个月',
      nextWeek: '下一周',
      nextMonth: '下个月',
      nextYear: '明年',
      prevYear: '去年',
      month: '月',
      month1: '1 月',
      month2: '2 月',
      month3: '3 月',
      month4: '4 月',
      month5: '5 月',
      month6: '6 月',
      month7: '7 月',
      month8: '8 月',
      month9: '9 月',
      month10: '10 月',
      month11: '11 月',
      month12: '12 月',
      year: '年',
      weeks: {
        sun: '日',
        mon: '一',
        tue: '二',
        wed: '三',
        thu: '四',
        fri: '五',
        sat: '六'
      },
      months: {
        m1: '一月',
        m2: '二月',
        m3: '三月',
        m4: '四月',
        m5: '五月',
        m6: '六月',
        m7: '七月',
        m8: '八月',
        m9: '九月',
        m10: '十月',
        m11: '十一月',
        m12: '十二月'
      },
      hour: '时',
      minute: '分',
      second: '秒'
    },
    transfer: {
      titles: {
        source: '源列表',
        target: '目的列表'
      },
      filterPlaceholder: '请输入搜索内容',
      notFoundText: '列表为空'
    },
    modal: {
      okText: '确定',
      cancelText: '取消',
      infoTitle: '提示信息',
      successTitle: '成功提示信息',
      warningTitle: '警告提示信息',
      errorTitle: '错误提示信息',
      confirmTitle: '确认信息'
    },
    poptip: {
      okText: '确定',
      cancelText: '取消'
    },
    page: {
      prev: '上一页',
      next: '下一页',
      total: '共',
      item: '条',
      items: '条',
      prev5: '向前 5 页',
      next5: '向后 5 页',
      page: '条/页',
      goto: '跳至',
      p: '页'
    },
    rate: {
      star: '星',
      stars: '星'
    },
    tree: {
      emptyText: '暂无数据'
    },
    slider: {
      'minError': 'max参数的值必须大于min参数的值，请联系开发人员。',
      'minErrorName': 'Slider组件参数错误'
    },
    cascader: {
      placeholder: '请选择',
      loading: '加载中'
    },
    tabs: {
      more: '更多'
    },
    calendar: {
      months: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
      shortMonths: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
      weeks: ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
    }
  }
}



// WEBPACK FOOTER //
// ./src/locale/lang/zh-CN.js